import React from "react";
import PropTypes from "prop-types";
import config from "../../../config";
import { AddToCartButton } from "../homePageComponents/ButtonComponents";
import { useNavigate } from "react-router-dom";
import RatingStars from "../homePageComponents/RatingStars";

export default function BookWishlistItem({ book, imageUrl, date, onRemove }) {
  const {
    bookName: title = "Unknown Title",
    bookPublication: publisher = "Unknown Publisher",
    bookIsbn10,
    bookIsbn13,
    bookStockStatus,
    author,
  } = book;

  const isbn = bookIsbn13 || bookIsbn10 || "N/A";
  const inStock = book.bookStockStatus === "IN_STOCK";
  const authorName = author?.authorName || "Unknown Author";
  const navigate = useNavigate();

  return (
    <div className="flex flex-col md:flex-row md:items-start justify-between p-4 border-b gap-4">
      {/* Mobile layout: Image + Info in row */}
      <div
        className="flex flex-row sm:flex-col md:flex-row items-start gap-4 w-full md:w-2/3 cursor-pointer"
        onClick={() => navigate(`/book/${book.bookId}`)}
      >
        <img
          src={
            imageUrl && imageUrl !== "defaultImage.jpg"
              ? `${config.url}${imageUrl}`
              : "/images/defaultBook.png"
          }
          alt={`${title} cover`}
          className="w-24 h-32 object-cover rounded border"
        />

        <div className="space-y-1">
          <h3 className="text-lg font-semibold text-text.black line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-text.muted">Author: {authorName}</p>
          <p className="text-sm text-text.muted">Publisher: {publisher}</p>
          <p className="text-sm text-text.muted">ISBN: {isbn}</p>
          <div className="mt-1">
            <RatingStars rating={book.averageRating} size={16} />
          </div>
        </div>
      </div>

      {/* Center: Date + Stock */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center w-full md:w-1/3 sm:space-x-4 gap-1 md:gap-20">
        <span className="text-sm text-text.black whitespace-nowrap">
          {date}
        </span>
        <span
          className={`text-sm font-medium whitespace-nowrap ${
            inStock ? "text-green-500" : "text-red-500"
          }`}
        >
          {inStock ? "In Stock" : "Out of Stock"}
        </span>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row md:flex-col items-center justify-end gap-2 w-full md:w-1/6 mt-2 md:mt-0">
        <AddToCartButton
          book={{ ...book, id: book.bookId }}
          className="w-full sm:w-28 px-2 py-1 text-sm"
        />
        <button
          onClick={onRemove}
          className="w-full sm:w-28 px-2 py-1 text-sm border border-primary rounded text-primary hover:bg-primary hover:text-white transition"
        >
          Remove
        </button>
      </div>
    </div>
  );
}

BookWishlistItem.propTypes = {
  book: PropTypes.shape({
    bookName: PropTypes.string,
    bookPublication: PropTypes.string,
    bookIsbn10: PropTypes.string,
    bookIsbn13: PropTypes.string,
    bookStockStatus: PropTypes.string,
    author: PropTypes.shape({
      authorName: PropTypes.string,
    }),
    rating: PropTypes.number,
  }).isRequired,
  imageUrl: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  onAddToCart: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
};
